import { Link } from '@mui/material';
import { Stack } from '@mui/system';
import { Link as RouterLink } from 'react-router-dom';
import type { DocItem } from 'src/@types/docs';
import { routes } from 'src/Router';
import { DocAvatar } from 'src/features/doc/DocAvatar';

export const MentionDocNodeView = ({
  doc,
}: {
  doc: Pick<DocItem, '_id' | 'title' | 'icon'>;
}) => {
  return (
    <Link
      component={RouterLink}
      to={routes.dashboard.docs.view(doc._id)}
      sx={{
        display: 'inline-flex',
        verticalAlign: 'middle',
        color: 'var(--theme-color-primary)',
        textDecoration: 'none !important',
        width: 'fit-content',
        '&:hover': {
          textDecoration: 'none',
          backgroundColor: 'var(--theme-color-primary)',
          color: 'var(--theme-color-primary)',
        },
      }}
    >
      <Stack direction="row" alignItems="center" gap={0.5}>
        <DocAvatar icon={doc.icon?.value} />
        {doc.title}
      </Stack>
    </Link>
  );
};
